// extracted by mini-css-extract-plugin
export default {"title":"PropFeatureList_title__me77O","feature":"PropFeatureList_feature__gIB06"};